import { DropdownMenu, GhostIconButton, MenuItem } from "@certn/cascadia-react";
import { Trans, useTranslation } from "react-i18next";

interface PaymentProfileActionDropdownProps {
  profileId: string;
  isArchived: boolean;
  handleOpenArchiveModal: () => void;
  handleRestore: () => void;
}

export function PaymentProfileActionDropdown(
  props: PaymentProfileActionDropdownProps
) {
  const { isArchived, handleOpenArchiveModal, handleRestore } = props;
  const { t } = useTranslation();

  const handleChangeStatus = () => {
    if (isArchived) {
      handleRestore();
    } else {
      handleOpenArchiveModal();
    }
  };

  return (
    <DropdownMenu
      triggerButton={
        <GhostIconButton
          testID="payment-profile-actions-expand-menu-button"
          size="small"
          icon="more_horiz"
          aria-label={t("Expand menu")}
        />
      }
      onItemAction={(key) => {
        switch (key) {
          case "chang_profile_status":
            handleChangeStatus();
            break;
        }
      }}
    >
      <MenuItem
        id="chang_profile_status"
        testID="payment-profile-change-profile-status-button"
        textColor={isArchived ? undefined : "text-danger"}
      >
        {isArchived ? (
          <Trans>Restore profile</Trans>
        ) : (
          <Trans>Archive profile</Trans>
        )}
      </MenuItem>
    </DropdownMenu>
  );
}
